var map = {
	"./breakfast/food-1.png": 2666,
	"./breakfast/food-2.png": 938,
	"./breakfast/food-3.png": 9587,
	"./breakfast/food-4.png": 8625,
	"./breakfast/food-5.png": 5567,
	"./breakfast/food-6.png": 2694,
	"./breakfast/food-7.png": 2971,
	"./breakfast/food-8.png": 2919,
	"./dessert/food-1.png": 9830,
	"./dessert/food-2.png": 330,
	"./dessert/food-3.png": 993,
	"./dessert/food-4.png": 6338,
	"./dessert/food-5.png": 8118,
	"./dessert/food-6.png": 5456,
	"./dessert/food-7.png": 7749,
	"./dessert/food-8.png": 2818,
	"./dinner/food-1.png": 3201,
	"./dinner/food-2.png": 6357,
	"./dinner/food-3.png": 7924,
	"./dinner/food-4.png": 734,
	"./dinner/food-5.png": 7892,
	"./dinner/food-6.png": 2255,
	"./dinner/food-7.png": 2013,
	"./dinner/food-8.png": 7498,
	"./drink/food-1.png": 8559,
	"./drink/food-2.png": 6556,
	"./drink/food-3.png": 8310,
	"./drink/food-4.png": 7394,
	"./drink/food-5.png": 8451,
	"./drink/food-6.png": 2120,
	"./drink/food-7.png": 2341,
	"./drink/food-8.png": 7752,
	"./lunch/food-1.png": 7372,
	"./lunch/food-2.png": 9922,
	"./lunch/food-3.png": 6220,
	"./lunch/food-4.png": 6673,
	"./lunch/food-5.png": 8063,
	"./lunch/food-6.png": 2895,
	"./lunch/food-7.png": 1213,
	"./lunch/food-8.png": 5146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 497;